import { useProgressReportStore } from '@stores/progress-report'

import { useProgressReportApi } from '@api/disciplines/progress-reports/report.hook'
import { onDisciplineReady } from '@hooks/discipline/on-discipline-ready.hook'

import { show404 } from '@utils/pages/error'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware(async (to) => {
  const progressReportStore = useProgressReportStore()

  const progressReportId: string | null = to?.params?.report as string || null
  onDisciplineReady((discipline) => {
    const isSameReportReady = progressReportStore.getReportStatus(discipline.id) === 'ready'
      && String(progressReportStore.getReportById(discipline.id)?.id) === progressReportId

    void useProgressReportApi({
      disciplineId: discipline.id,
      progressReportId,
      mode: isSameReportReady ? 'refresh' : 'enter',
    }, {
      onError: () => {
        return show404()
      },
    })
  }, { hook: 'NONE' })
})
